import { QuestionProcessingStatuses } from '../constants/question-processing-statuses'
import { isNumber } from 'lodash'
import { flatten } from './array.helper'

export const getAnswerByQuestion = (answers, question, focusedQuestionId) => {
    if (!answers || !question) return

    let answer = answers.find(answer => answer.questionId === question.id)

    if (question.parentId) {
        const parentAnswer = answers.find(answer => answer.questionId === question.parentId)
        if (parentAnswer) answer = { ...answer, content: parentAnswer.content }
    }

    if (question.children) {
        const focusedQuestionIdIsChild = isNumber(focusedQuestionId) && question.children.some(child => child.id === focusedQuestionId)
        const childrenAnswer = focusedQuestionIdIsChild
            ? answers.find(answer => answer.questionId === focusedQuestionId)
            : answers.find(answer => answer.questionId === question.children[0].id)

        answer = { ...answer, ...childrenAnswer, content: answer.content }
    }

    return answer
}

export const getQuestionsTrainingStats = questions => {
    const flattenedQuestions = flatten(questions, { excludeParents: true })
    const numberOfTrainedQuestions = flattenedQuestions?.filter(question => question.lastTrained)?.length || 0
    const percentOfTrainedQuestions = Math.round(
        flattenedQuestions?.length > 0 ? (numberOfTrainedQuestions / flattenedQuestions.length) * 100 : 0,
    )
    const trainableQuestionsNumber = flattenedQuestions.length
    const allQuestionsTrained = numberOfTrainedQuestions === trainableQuestionsNumber

    return { numberOfTrainedQuestions, percentOfTrainedQuestions, trainableQuestionsNumber, allQuestionsTrained }
}

export const getQuestionProcessingInfo = question => {
    if (!question) {
        return {
            message: 'Invalid question',
            progress: 0,
        }
    }

    // Handle parent questions
    if (question.children) {
        const totalChildren = question.children.length
        const trainedChildren = question.children.filter(child => child.lastTrained).length

        const progress = Math.round((trainedChildren / totalChildren) * 100)
        const message = `${trainedChildren}/${totalChildren} Trained`

        return {
            message,
            progress,
        }
    }

    let message = question.processing.message || ''
    let progress = question.processing.progress || 0

    if (question.processing.status === QuestionProcessingStatuses.READY) {
        message = question.lastTrained ? 'Trained' : 'Not Trained'
        progress = question.lastTrained ? 100 : 0
    }

    return {
        message,
        progress,
    }
}
